import { useEffect } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Spinner } from '@factorialco/f0-react/dist/experimental'
import { UpsellLandingPagesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { getDatoLocale } from 'modules/onboarding/lib/datoLocale'
import LaunchesWithCEOPageBannerSection from 'modules/product_updates/pages/LaunchesWithCEOPage/_BannerSection'
import { LaunchesWithCEOPageFeaturesSection } from 'modules/product_updates/pages/LaunchesWithCEOPage/_FeaturesSection'
import LaunchesWithCEOPageHeader from 'modules/product_updates/pages/LaunchesWithCEOPage/_Header'
import LaunchesWithCEOPageProductUpdatesSection from 'modules/product_updates/pages/LaunchesWithCEOPage/_ProductUpdatesSection'

const LaunchesWithCEOPage = () => {
  const {
    access: { locale: accessLocale },
    canRequestUpsell,
  } = useCurrentSession()

  const locale = getDatoLocale(accessLocale)
  const { data, loading } = useQuery(UpsellLandingPagesDocument, {
    variables: {
      locale: locale,
      preview: true,
      slug: 'launches-with-ceo-q4',
    },
  })

  const content = data?.upsell.landingPagesConnection.edges[0]?.node

  useEffect(() => {
    track(trackingEvents.productUpdates.viewLaunchesWithCEO)
  }, [])

  if (loading) {
    return <Spinner />
  }

  return (
    <ResponsivePage.Body showHeader={false} variant="wide">
      <Box gap="s80" style={{ maxWidth: '1200px', margin: '80px auto', paddingBottom: '40px' }}>
        <LaunchesWithCEOPageHeader content={content} />
        <LaunchesWithCEOPageFeaturesSection content={content} />
        {canRequestUpsell && <LaunchesWithCEOPageBannerSection content={content} />}
        <LaunchesWithCEOPageProductUpdatesSection content={content} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default LaunchesWithCEOPage
